<template>
    <div class="page-container">
        <!--工具栏-->
        <div class="toolbar" style="float:left;padding-top:10px;padding-left:15px;text-align:left">
            <el-form :inline="true" :model="filters" :size="size">
                <el-form-item label="院校ID" prop="schoolId">
                    <el-input v-model="filters.schoolId" placeholder="请输入院校ID" style="width:140px"></el-input>
                </el-form-item>
                <el-form-item label="省份" prop="provinceId">
                    <el-select v-model="filters.provinceId" placeholder="请选择省份" style="width:140px">
                        <el-option v-for="item in provinceList" :key="item.code" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="院校名称" prop="schoolName">
                    <el-input v-model="filters.schoolName" placeholder="请输入院校名称" style="width:140px"></el-input>
                </el-form-item>
<!--                <el-form-item label="统校考" prop="examTypeValue">-->
<!--                    <el-select v-model="filters.examTypeValue" placeholder="请选择考试类型" style="width:140px">-->
<!--                        <el-option key="1" label="统考及校考" value="1"></el-option>-->
<!--                        <el-option key="2" label="统考" value="2"></el-option>-->
<!--                        <el-option key="3" label="校考" value="3"></el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item>
                    <perm-button icon="fa fa-search" label="搜索" perms="sch:school:list" type="primary"
                        @click="findPage({ pageRequest: { current: 1, size: 10 } })" />
                </el-form-item>
<!--                <el-form-item>-->
<!--                    <perm-button icon="fa fa-plus" label="新增" perms="wish:school:add" type="success"-->
<!--                        @click="handleAdd" />-->
<!--                </el-form-item>-->
            </el-form>
        </div>
        <div class="toolbar" style="float:right;padding-top:10px;padding-right:15px;">
            <!--表格显示列界面-->
            <table-column-filter-dialog ref="tableColumnFilterDialog" :columns="columns"
                @handleFilterColumns="handleFilterColumns">
            </table-column-filter-dialog>
        </div>
        <!--表格树内容栏-->
        <perm-table :page="page"
                    :columns="columns"
                    :selectionChange="selectionChange"
                    :handleCurrentHandle="handleCurrentHandle"
                    :loading="loading"
                    size="mini"
                    @findPage="findPage"
                    @handleEdit="handleEdit"
                    @handleDelete="handleDelete"
                    permsEdit="sch:school:update"
                    permsDelete="sch:school:delete">
        </perm-table>
        <!-- 新增修改界面 -->
        <el-dialog :title="!dataForm.createTime ? '新增院校信息' : '编辑院校信息'" width="50%" :visible.sync="dialogVisible"
            :close-on-click-modal="false" @close='cancel'>
            <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="submitForm()"
                label-width="100px" :size="size" style="text-align:left;" v-loading="loadingData">
                <el-collapse v-model="activeNames">
                    <el-collapse-item name="1">
                        <span slot="title" style='font-weight:900'>
                            基础信息
                        </span>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="省份" prop="provinceId">
                                    <el-select v-model="dataForm.provinceId"
                                               style='width:203px' placeholder="请选择院校省份"
                                               :disabled="Boolean(dataForm.createTime)">
                                        <el-option v-for="item in provinceList" :key="item.code" :label="item.name"
                                            :value="item.code">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="院校编码" prop="schoolId">
                                    <el-input style='width:203px' :disabled="Boolean(dataForm.createTime)"
                                        v-model="dataForm.schoolId" placeholder="请输入院校编码"></el-input>
                                </el-form-item>
                                <el-form-item label="院校名称" prop="schoolName" :disabled="Boolean(dataForm.createTime)">
                                    <el-input style='width:203px' v-model="dataForm.schoolName" placeholder="请输入院校名称">
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="统/校考" prop="examType" :disabled="Boolean(dataForm.createTime)">
                                    <el-radio v-model="dataForm.examType" label='统考及校考' style='margin-right:10px'>统考及校考
                                    </el-radio>
                                    <el-radio v-model="dataForm.examType" label='统考' style='margin-right:10px'>统考
                                    </el-radio>
                                    <el-radio v-model="dataForm.examType" label='校考' style='margin-right:0px'>校考
                                    </el-radio>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="办学层次" prop="schoolLevel" :disabled="Boolean(dataForm.createTime)">
                                    <el-radio v-model="dataForm.schoolLevel" label='本科'>本科</el-radio>
                                    <el-radio v-model="dataForm.schoolLevel" label='专科'>专科</el-radio>
                                </el-form-item>
                                <el-form-item label="启用标志" prop="dataStatus" :disabled="Boolean(dataForm.createTime)">
                                    <el-switch v-model="dataForm.dataStatus" active-color="#13ce66"
                                        inactive-color="#ff4949">
                                    </el-switch>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-form-item label="校考信息" prop="examInfo">
                            <div id="editor1"></div>
                            <!-- <el-input type="textarea" :rows=3 v-model="dataForm.examInfo"
                                      placeholder="请输入校考信息富文本内容"></el-input> -->
                        </el-form-item>
                        <el-form-item label="考试科目" prop="subject">
                            <div id="editor2"></div>
                            <!-- <el-input type="textarea" :rows=3 v-model="dataForm.subject"
                                      placeholder="请输入考试科目富文本内容"></el-input> -->
                        </el-form-item>
                    </el-collapse-item>
                </el-collapse>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button :size="size" @click="cancel">取消</el-button>
                <el-button :size="size" type="primary" :loading="editLoading" @click="submitForm()">确认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import PopupTreeInput from '../../Component/PopupTreeInput/Index'
import PermButton from '../../Component/PermButton/Index'
import PermTable from '../../Component/PermTable/Index'
import TableColumnFilterDialog from '../../Component/TableColumnFilterDialog/Index'
import CascadeSearch from '../../Component/CascadeSearch/Index'
import provinceAndCity from '../../CommonData/provinceAndCity'
import {
    baseUrl,
    uploadUrl
} from '../../../utils/global'
import { updateSchExamSchool } from '../../../http/moudules/wish/school'
import MyCustomUploadAdapterPlugin from '../../../utils/uploadAdapter'

export default {
    name: 'SchoolExamSchool',
    components: {
        PermTable,
        PermButton,
        PopupTreeInput,
        TableColumnFilterDialog,
        CascadeSearch
    },
    data: function() {
        return {
            multiple: true,
            loadingData: false,
            upload: {
                url: uploadUrl + '/common/image/upload',
                videoUrl: uploadUrl + '/common/file/upload'
            },
            headers: {
                'access-token': sessionStorage.getItem('access-token')
            },
            activeNames: '1',
            editor1: '',
            editor2: '',
            size: 'small',
            loading: false,
            editLoading: false,
            filters: {
                provinceId: '',
                schoolId: '',
                schoolName: '',
                examType: ''
            },
            filterColumns: [],
            columns: [],
            page: {},
            pageRequest: {
                current: 1,
                size: 10
            },
            typeList: [],
            provinceList: [],
            dialogVisible: false,
            dataForm: {
                schoolId: '',
                schoolNo: '',
                schoolName: '',
                tagNames: '',
                provinceId: '',
                provinceName: '',
                schoolLevel: '',
                askUrl: '',
                examInfo: '',
                subject: '',
                admissionYear: '',
                admissionNum: '',
                examType: '',
                startTime: '',
                endTime: '',
                dataStatus: false
            },
            dataRule: {
                provinceId: [{
                    required: true,
                    message: '省份不能为空',
                    trigger: 'change'
                }],
                schoolName: [{
                    required: true,
                    message: '院校名称不能为空',
                    trigger: 'blur'
                }],
                schoolCode: [{
                    required: true,
                    message: '院校编码不能为空',
                    trigger: 'blur'
                }],
                schoolId: [{
                    required: true,
                    message: '院校编码不能为空',
                    trigger: 'blur'
                }],
                examType: [{
                    required: true,
                    message: '统/校考不能为空',
                    trigger: 'blur'
                }]
            },
            acquiesce: {}
        }
    },
    methods: {
        handleRemove() { },
        handleError() {
            debugger
        },
        handleExceed(q, w) {
            debugger
        },
        handleBeforeUpload(file) {
            debugger
            const isImage = file.type === 'image/jpeg' || 'image/gif' || 'image/png'
            const isLt1M = file.size / 1024 / 1024 < 1
            if (!isImage) {
                this.upload.message = '上传文件只能是图片格式!'
                this.$message({
                    message: this.upload.message,
                    type: 'error'
                })
            }
            if (!isLt1M) {
                this.upload.message = '上传文件大小不能超过 1MB!'
                this.$message({
                    message: this.upload.message,
                    type: 'error'
                })
            }
            return isImage && isLt1M
        },
        handleBeforeUploadVideo(file) {
            const isVideo = file.type === 'video/mp4' || 'video/rmvb' || 'video/mov'
            const isLt20M = file.size / 1024 / 1024 < 20
            if (!isVideo) {
                this.upload.message = '上传文件只能是视频格式!'
                this.$message({
                    message: this.upload.message,
                    type: 'error'
                })
            }
            if (!isLt20M) {
                this.upload.message = '上传文件大小不能超过 20MB!'
                this.$message({
                    message: this.upload.message,
                    type: 'error'
                })
            }
            return isVideo && isLt20M
        },
        handleSuccess(response, file, fileList) {
            console.log(file)
            if (response.success) {
                this.upload.message = ''
                this.$message({
                    message: '上传成功',
                    type: 'success'
                })
            } else {
                this.upload.message = response.message
                this.$message({
                    message: response.message,
                    type: 'error'
                })
            }
        },
        cancel: function() {
            this.dialogVisible = false
            this.activeNames = '1'
            this.editLoading = false
            this.$refs.dataForm.resetFields()
            this.editor1.setData('')
            this.editor2.setData('')
            // this.$refs.tagNames.setCheckedKeys([])
            // this.$refs.upLoadFormImg.clearFiles()
            // this.$refs.upLoadForm.clearFiles()
        },
        // 获取分页数据
        findPage: function(data) {
            this.loading = true
            if (data != null) {
                this.pageRequest = data.pageRequest
            }
            let param = {
                provinceId: this.filters.provinceId,
                schoolName: this.filters.schoolName,
                schoolId: this.filters.schoolId,
                examTypeValue: this.filters.examTypeValue
            }
            param = Object.assign(param, this.pageRequest)
            this.$api.school.getSimpleSchExamSchoolList(param).then(res => {
                if (res && !res.success) {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    })
                    this.loading = false
                    return
                }
                this.page = res.data

                this.loading = false
            }).then(data != null ? data.callback : '')
        },
        initEditor(con) {
            const { ClassicEditor } = window
            const config = {
                language: 'zh-cn',
                extraPlugins: [MyCustomUploadAdapterPlugin]
            }
            this.$nextTick(() => {
                if (this.editor1) {
                    let content = ''
                    if (con && con.examInfo) {
                        content = con.examInfo
                    }
                    this.editor1.setData(content)
                    const contentWrap = document.querySelector('.ck-content')
                    contentWrap.scroll(0, 0)
                } else {
                    const el1 = document.getElementById('editor1')
                    ClassicEditor.create(el1, config).then((editor) => {
                        this.editor1 = editor
                        if (con && con.examInfo) {
                            this.editor.setData(con.examInfo)
                        }
                    })
                }
                if (this.editor2) {
                    let content = ''
                    if (con && con.subject) {
                        content = con.subject
                    }
                    this.editor2.setData(content)
                    const contentWrap = document.querySelector('.ck-content')
                    contentWrap.scroll(0, 0)
                    return
                } else {
                    const el2 = document.getElementById('editor2')
                    ClassicEditor.create(el2, config).then((editor) => {
                        this.editor2 = editor
                        if (con && con.subject) {
                            this.editor2.setData(con.subject)
                        }
                    })
                }
            })
        },
        // 显示新增界面
        handleAdd: function() {
            this.dialogVisible = true
            this.dataForm = {
                provinceId: this.acquiesce.provinceId ? this.acquiesce.provinceId : '',
                schoolId: '',
                schoolNo: '',
                schoolName: '',
                tagNames: '',
                provinceName: '',
                schoolLevel: '',
                askUrl: '',
                examInfo: '',
                subject: '',
                admissionYear: '',
                admissionNum: '',
                examType: '',
                startTime: '',
                endTime: '',
                dataStatus: false
            }
            this.initEditor()
        },
        // 显示编辑界面
        handleEdit: function(data) {
            this.dialogVisible = true
            this.activeNames = ''
            this.loadingData = true
            const param = {
                schoolId: data.row.schoolId
            }
            this.$api.school.getSchExamSchoolInfo(param).then(res => {
                this.activeNames = '1'
                this.loadingData = false
                if (res && !res.success) {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    })
                    return
                }
                this.dataForm = res.data
                if (this.dataForm.dataStatus) {
                    switch (this.dataForm.dataStatus) {
                        case 0:
                            this.dataForm.dataStatus = false
                            break
                        case 1:
                            this.dataForm.dataStatus = true
                            break
                    }
                    this.dataForm.provinceId = res.data.provinceId ? String(res.data.provinceId) : ''
                }
                this.initEditor({
                    examInfo: res.data.examInfo,
                    subject: res.data.subject
                })
            })
        },
        // 删除
        handleDelete(data) {
            this.$confirm('确认删除选中记录吗？', '提示', {
                type: 'warning'
            }).then(() => {
                const params = this.getDeleteIds([], data.row)
                this.$api.school.deleteSchExamSchool(params).then(res => {
                    if (!res.success) {
                        this.$message({
                            message: res.message,
                            type: 'error'
                        })
                        return
                    }
                    this.$message({
                        message: '删除成功',
                        type: 'success'
                    })
                    this.findPage(null)
                })
            })
        },
        // 获取删除的包含子分类的id列表
        getDeleteIds(ids, row) {
            ids.push(row.schoolId)
            if (row.children != null) {
                for (let i = 0, len = row.children.length; i < len; i++) {
                    this.getDeleteIds(ids, row.children[i])
                }
            }
            return ids
        },
        selectionChange(selections) {
            console.log(selections)
        },
        handleCurrentHandle: function(val) {
            console.log('handleCurrentHandle>>' + val)
        },
        // 表单提交
        submitForm() {
            var callback = (res) => {
                this.editLoading = false
                if (res.success) {
                    this.$message({
                        message: '操作成功',
                        type: 'success'
                    })
                    this.$refs['dataForm'].resetFields()
                    this.dialogVisible = false
                    // 当前页
                    this.findPage(null)
                } else {
                    this.$message({
                        message: res.message,
                        type: 'error'
                    })
                }
            }
            this.$refs['dataForm'].validate(valid => {
                if (valid) {
                    this.$confirm('确认提交吗？', '提示', {}).then(() => {
                        debugger
                        this.editLoading = true
                        const params = Object.assign({}, this.dataForm)
                        // console.log(this.$refs.tagNames.getCheckedNodes())
                        // params.tagNames = this.$refs.tagNames.getCheckedNodes() ? this.$refs.tagNames
                        //     .getCheckedNodes().map(item => {
                        //         return item.label
                        //     }).join(',') : ''
                        // params.typeIdList = this.$refs.tagNames.getCheckedKeys().filter(item => {
                        //     return !!item
                        // })
                        params.dataStatus = this.dataForm.dataStatus ? 1 : 0
                        params.examInfo = this.editor1.getData()
                        params.subject = this.editor2.getData()
                        console.log(params, 'params')
                        if (!this.dataForm.createTime) {
                            // params.examType = Number(params.examType)
                            // this.$api.school.saveSchool(params).then(res => {
                            //     callback(res)
                            // })
                        } else {
                            // params.examType = Number(params.examType)
                            this.$api.school.updateSchExamSchool(params).then(res => {
                                callback(res)
                            })
                        }
                    })
                }
            })
        },
        // 初始化表格
        initColumns: function() {
            this.columns = [
                {
                    prop: 'schoolId',
                    label: 'ID',
                    minWidth: 120
                },
                {
                    prop: 'schoolName',
                    label: '院校名称',
                    minWidth: 130
                },
                {
                    prop: 'tagNames',
                    label: '院校标签',
                    minWidth: 150
                },
                {
                    prop: 'provinceName',
                    label: '省份',
                    minWidth: 100
                },
                {
                    prop: 'schoolLevel',
                    label: '办学层次',
                    minWidth: 50
                }
            ]
            this.filterColumns = JSON.parse(JSON.stringify(this.columns))
        },
        // 处理表格列过滤显示
        displayFilterColumnsDialog: function() {
            this.$refs.tableColumnFilterDialog.setDialogVisible(true)
        },
        // 处理表格列过滤显示
        handleFilterColumns: function(data) {
            this.filterColumns = data.filterColumns
            this.$refs.tableColumnFilterDialog.setDialogVisible(false)
        },
        onContentChange(val) {
            this.dataForm.content = val
        },
        loadTypeListAll() {
            this.$api.school.typeListAll().then(res => {
                var label = res.data.filter(item => {
                    return item.typeFlag === '标签'
                }).map(item => {
                    return {
                        id: item.typeId,
                        label: item.typeName
                    }
                })
                var cat = res.data.filter(item => {
                    return item.typeFlag === '类别'
                }).map(item => {
                    return {
                        id: item.typeId,
                        label: item.typeName
                    }
                })
                var prof = res.data.filter(item => {
                    return item.typeFlag === '专业'
                }).map(item => {
                    return {
                        id: item.typeId,
                        label: item.typeName
                    }
                })
                var subject = res.data.filter(item => {
                    return item.typeFlag === '科目'
                }).map(item => {
                    return {
                        id: item.typeId,
                        label: item.typeName
                    }
                })
                this.typeList = [{
                    // id: 1,
                    label: '标签',
                    children: label
                }, {
                    // id: 2,
                    label: '类别',
                    children: cat
                }, {
                    // id: 3,
                    label: '专业',
                    children: prof
                }, {
                    // id: 5,
                    label: '科目',
                    children: subject
                }]
            })
        }
    },
    mounted() {
        this.loadTypeListAll()
        this.initColumns()
        this.provinceList = provinceAndCity.provinceAndCity
        this.acquiesce = this.$store.state.baseProvinceList.acquiesce
        this.findPage(null)
    }
}
</script>

<style scoped>
.flex {
    overflow: auto;
    display: flex;
    flex-wrap: nowrap
}

.pic-list {
    width: 100px;
    margin: 0 5px;
    flex-shrink: 0;
}

.pic-list img {
    max-width: 100%;
}

.pic-list video {
    max-width: 100%;
}

.video-list {
    width: 200px;
    margin: 0 10px 10px 0;
    text-align: center
}

.video-list video,
.video-list img {
    max-width: 100%
}

.video-list img {
    display: block
}
</style>



// WEBPACK FOOTER //
// src/components/Manager/Tkinfo/SchoolExamSchool.vue